const PH_CALIBRATION_FLOW_UPDATED = 'PH_CALIBRATION_FLOW_UPDATED'
const PH_CALIBRATION_FLOW_RESET = 'PH_CALIBRATION_FLOW_RESET'

const initialState = {
  calibrationId: null,
  cancelCalibration: false,
  currentCalibration: null,
  currentTab: 'list',
  error: [],
  hasStartedCalibration: false,
  hasTriggeredAction: null,
  isPending: false,
  seconds: 0,
  startTime: null,
  success: [],
  waitingForSuccess: false,
}

const phSensorCalibrationFlowBundle = {
  name: 'phSensorCalibrationFlow',
  reducer: (state = initialState, action = {}) => {
    switch (action.type) {
      case PH_CALIBRATION_FLOW_UPDATED:
        return { ...state, ...action.payload }
      case PH_CALIBRATION_FLOW_RESET:
        return initialState
      default:
        return state
    }
  },
  selectPhSensorCalibrationFlow: state => state.phSensorCalibrationFlow,
  doUpdatePhSensorCalibrationFlow: payload => ({ dispatch }) => {
    dispatch({ type: PH_CALIBRATION_FLOW_UPDATED, payload })
  },
  doResetPhSensorCalibrationFlow: () => ({ dispatch }) => {
    dispatch({ type: PH_CALIBRATION_FLOW_RESET })
  }
}

export default phSensorCalibrationFlowBundle
